import React from "react";
import leftArrow from "../../assets/leftArrow.svg";
import PlanCard from "../../components/_subscription/PlanCard/PlanCard";
import Storage from "../../components/_subscription/Storage/Storage";
import Total from "../../components/_subscription/Total/Total";
import Layout from "../../shared/Layout/Layout";
import styles from "./Subscription.module.scss";

const Subscription = () => {
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.subContainer}>
          <div className={styles.leftArrow}>
            <img src={leftArrow} alt="go-back" />
          </div>
          <h1>Subscription</h1>

          <PlanCard />
          <Storage />
          <Total />
        </div>
      </div>
    </Layout>
  );
};

export default Subscription;
